<template>
  <view-container>
    <v-row>
      <v-col cols="12" md="8">
        <ClientForm :id="id" @saved="close">
          <v-btn text @click="close">Отмена</v-btn>
        </ClientForm>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>Статистика</v-card-title>
          <v-card-text>
            <v-container class="subtitle-2 font-weight-black pa-0"
              >Максимальное число активных кассиров</v-container
            >
            <v-container>
              <v-row>
                <v-col cols="10" class="pa-0">
                  В этом месяце:
                </v-col>
                <v-col cols="2" class="pa-0">
                  {{ currMonthMax }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" class="pa-0">
                  В предыдущем месяце:
                </v-col>
                <v-col cols="2" class="pa-0">
                  {{ prevMonthMax }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </view-container>
</template>
<script>
import ClientForm from "@/components/ui/forms/ClientForm";
import ds from "@/datastore";
export default {
  name: "ClientEdit",
  components: {
    ClientForm
  },
  props: {
    id: String
  },
  data() {
    return {
      client: {}
    };
  },
  computed: {
    prevMonthMax() {
      return this.client.cashiersEmployment
        ? this.client.cashiersEmployment[0]
        : "н/д";
    },
    currMonthMax() {
      return this.client.cashiersEmployment
        ? this.client.cashiersEmployment[1]
        : "н/д";
    }
  },
  async created() {
    if (this.id) {
      this.client = await ds.find("client", this.id);
    }
  },
  methods: {
    close() {
      this.$destroy();
      this.$router.go(-1);
    }
  }
};
</script>
